import AWS from "aws-sdk";
import { CookieStorage } from "amazon-cognito-identity-js";
import request from "superagent";
import _ from "lodash";
import moment from "moment";
import { Auth } from "aws-amplify";
import fetchIntercept from "fetch-intercept";

import env from "../constants/env";
import state from "../state/state";
import { isOrganizationAdministrator, isOrganizationAuthor, getJwtToken } from "../actions/user";
import { postMessage, sendDebugLogMessage, sendLogoutMessage, sendTokenUpdatedMessage } from "../actions/mobileAppCommunicationActions";
import { forceLogin } from "../actions/actions";
import browserHistory from "../history";
import { showError } from "../actions/alertActions";
import { getQueryStringParam, isMobile } from "./utils";
import { jwtNeedsRenewal } from "./jwtExpiryUtils";
import { createCloudFrontCookieGuard } from "./cloudFrontCookieGuard";
import { handlePostAuthenticateV2, handleRemotePlayerAuth } from "../actions/portalActions";


import { Hub } from "aws-amplify";
// window.LOG_LEVEL = 'DEBUG';
// https://login-haralds-test-org.auth.us-east-1.amazoncognito.com/oauth2/authorize?response_type=code&client_id=4m07lh8puago45hb1poi030ktv&redirect_uri=https://haralds-test-org.ambifi.com:3000

// This really sucks but we have a flaw in the amplify library where token requests get duplicated...
let lastTokenCall = 0;



let amplifyConfigured = false;
export function configureAmplify(config) {
	async function onAuthEvent(payload) {
		if (payload && payload.event) {
			try {
				const failure = /failure/i.test(payload.event);
				const data = payload.data || {};
				sendDebugLogMessage("Cloud Auth Hub event", {
					event: payload.event,
					hasData: !!payload.data,
					errorName: failure && data.name ? data.name : "",
					errorCode: failure && data.code ? data.code : "",
					errorMessage: failure && data.message ? data.message : ""
				});
			} catch (_e) { /* diagnostics only */ }

			switch (payload.event) {
				case "signIn": {
					if (!state.get(["appState", "enterprise"])) {
						// console.log("onAuthEvent (signIn)", payload);
						const authParams = getQueryStringParam("auth");
						if (authParams && true) {
							let session = await Auth.currentSession();
							handleRemotePlayerAuth(session);
						} else {
							await handlePostAuthenticateV2(payload.data.signInUserSession, payload.data, state, payload.data.username);
						}
					}

					break;
				}
				default: {
					console.debug("onAuthEvent (not signIn)", payload);
				}
			}
		}
	}
	if (!amplifyConfigured) {
		fetchIntercept.register({
			request: function (url, config) {
				// Modify the url or config here
				// console.log("INTERCEPTED FETCH", url, config);
				if (url && url.endsWith && url.endsWith("oauth2/token")) {
					const rightNow = new Date().getTime();
					if (lastTokenCall < rightNow - 1000) {
						// console.log("INTERCEPTED oauth2/token FETCH (continue)", url, config);
						// Longer than one second ago :)
						lastTokenCall = rightNow;
						return [url, config];
					} else {
						return null;
					}
				} else {
					return [url, config];
				}
			},

			requestError: function (error) {
				// Called when an error occured during another 'request' interceptor call
				return Promise.reject(error);
			},

			response: function (response) {
				// Modify the reponse object
				if (response.url === "https://cognito-idp.us-east-1.amazonaws.com/") {
					const reader = response.body.getReader();
					const stream = new ReadableStream({
						start(controller) {
							// The following function handles each data chunk
							function push() {
								// "done" is a Boolean and value a "Uint8Array"
								reader.read().then(({ done, value }) => {


									const strValue = new TextDecoder("utf-8").decode(value);
									console.log("GOT RESPONSE", strValue);
									let val = value;
									try {
										const objValue = JSON.parse(strValue);
										if (_.isPlainObject(objValue)) {
											// Inspect and see if we can find the email_verfied prop
											const newUserAttributes = [];
											if (objValue.UserAttributes && _.isArray(objValue.UserAttributes)) {
												objValue.UserAttributes.forEach(attr => {
													if (attr.Name === "email_verified") {
														let val = false;
														if (attr.Value === "True" || attr.Value === "true" || attr.Value === true) {
															val = true;
														}
														newUserAttributes.push({
															Name: attr.Name,
															Value: val
														});
													} else {
														newUserAttributes.push(attr);
													}
												});
											}
											objValue.UserAttributes = newUserAttributes;
											val = new TextEncoder("utf-8").encode(JSON.stringify(objValue));
										}
									} catch (e) {

									}


									// Is there no more data to read?
									if (done) {
										// Tell the browser that we have finished sending data
										controller.close();
										return;
									}

									// Get the data and send it to the browser via the controller
									controller.enqueue(val);
									push();
								});
							}

							push();
						}
					});

					return new Response(stream, { headers: { "Content-Type": "application/x-amz-json-1.1" } });
				} else {
					return response;
				}

			},

			responseError: function (error) {
				// Handle an fetch error
				return Promise.reject(error);
			}
		});
		Hub.listen("auth", (data) => {
			const { payload } = data;
			onAuthEvent(payload);
			// console.log("A new auth event has happened: ", payload);
		});
		amplifyConfigured = true;
	}
	// if (amplifyConfigured) {
	// 	return;
	// }

	// Amplify.configure({
	// 	Auth: {

	// 		// REQUIRED - Amazon Cognito Region
	// 		region: "us-east-1",

	// 		// OPTIONAL - Amazon Cognito User Pool ID
	// 		userPoolId: "us-east-1_CiDLIeTjb",

	// 		// OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
	// 		userPoolWebClientId: "4m07lh8puago45hb1poi030ktv",

	// 		// OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
	// 		mandatorySignIn: true,

	// 		// OPTIONAL - Configuration for cookie storage
	// 		// Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol
	// 		// cookieStorage: {
	// 		// 	// REQUIRED - Cookie domain (only required if cookieStorage is provided)
	// 		// 	domain: ".ambifi.com",
	// 		// 	// OPTIONAL - Cookie path
	// 		// 	path: "/",
	// 		// 	// OPTIONAL - Cookie expiration in days
	// 		// 	expires: 365,
	// 		// 	// OPTIONAL - Cookie secure flag
	// 		// 	// Either true or false, indicating if the cookie transmission requires a secure protocol (https).
	// 		// 	secure: true
	// 		// },

	// 		// // OPTIONAL - Hosted UI configuration
	// 		oauth: {
	// 			domain: "login-haralds-test-org.auth.us-east-1.amazoncognito.com", ///oauth2/authorize 
	// 			scope: ["email", "openid", "aws.cognito.signin.user.admin"],
	// 			redirectSignIn: "https://haralds-test-org.ambifi.com:3000",
	// 			redirectSignOut: "https://haralds-test-org.ambifi.com:3000",
	// 			responseType: "code" // or 'token', note that REFRESH token will only be generated when the responseType is code
	// 		}
	// 	}
	// });
	// console.log("Amplify configured!");
	// amplifyConfigured = true;
}



AWS.config.update({ region: env.aws.defaultRegion });

// const poolData = {
// 	UserPoolId: env.cognito.userPoolId, // Your user pool id here
// 	ClientId: env.cognito.clientId, // Your client id here
// };

// const userPool = new CognitoUserPool(poolData);

const REFRESH_INTERVAL_MINUTES = 15;
let intervalId = null;
let refreshCredentialsPromise = null;

let lastRefresh = null;
let lastRefreshFailed = false;
let sessionExpiryHandled = false;

// getSession()/Auth.currentSession() only renew an ID token that has already expired, so
// refreshCredentials() renews it itself once it is within the renewal margin (see jwtExpiryUtils).
// The watchdog covers API calls that read getJwtToken() without calling refreshCredentials() first.
const ID_TOKEN_CHECK_INTERVAL_SECONDS = 60;
// After a failed attempt, keep using the current token (if it still has this long left) instead of
// retrying the renewal on every call.
const ID_TOKEN_RENEWAL_RETRY_SECONDS = 30;
const ID_TOKEN_MIN_USABLE_SECONDS = 60;
const ID_TOKEN_WATCHDOG_BACKOFF_MINUTES = 5;
let idTokenCheckIntervalId = null;
let idTokenClockDriftSeconds = 0;
let lastIdTokenRenewalAttempt = null;
let lastIdTokenWatchdogFailure = null;

// Recovery: credentials that lapse while a computer sleeps (the CloudFront cookies for private files last two hours)
// failed every request until the next 15-minute refresh or a reload. Now a failed refresh is retried sooner, and
// credentials that are due are renewed as soon as the page is used again: the tab is shown, the browser comes back
// online or the computer wakes.
const REFRESH_RETRY_DELAYS_SECONDS = [30, 60, 120, 300];
// A 60-second watchdog tick that arrives this much later than due means the computer slept or the tab was frozen.
const WAKE_GAP_SECONDS = 150;
// Renew the CloudFront cookies once their signed policy has less than this left.
const COOKIE_RENEWAL_MARGIN_MINUTES = 20;
const MAX_RECORDED_REFRESH_FAILURES = 20;
let refreshRetryTimerId = null;
let refreshRetryCount = 0;
let refreshFailures = [];
let lastWatchdogTickMs = null;
let recoveryListenersAttached = false;

// Keeps this tab's CloudFront cookies (private files) in the browser while another AmbiFi site is open too.
const cloudFrontCookieGuard = createCloudFrontCookieGuard({
	getCookies: () => state.get(["security", "cookies"]),
	// A private image failed with this tab's own cookies in place: they may have lapsed.
	renewCredentials: () => (state.get(["user", "loggedIn"]) ? refreshCredentials(true, "privateImage") : Promise.reject(new Error("Not signed in")))
});

let cookieStorage = null;

// This may be something for later on, doesn't quite work as I've been testing it ... claims it's missing an ID token in local storage
export function getCookieStorage() {
	if (!cookieStorage) {
		cookieStorage = new CookieStorage({ domain: "localhost", secure: false });
	}

	return cookieStorage;
}

export function handlePageInit(location, requiresAdminPrivilege = false, requiresAuthorPrivilege = false) {
	const user = state.get(["user"]);
	if (!user.loggedIn) {
		forceLogin(browserHistory, location.pathname);
	} else if ((!isOrganizationAdministrator() && requiresAdminPrivilege) || (!isOrganizationAuthor() && !isOrganizationAdministrator() && requiresAuthorPrivilege)) {
		browserHistory.push("/home");
	}
}

export function getSecurityContext() {
	return {
		cognitoUserPool: {
			UserPoolId: env.cognito.userPoolId, // Your user pool id here
			ClientId: env.cognito.clientId, // Your client id here
		},
		region: env.aws.defaultRegion,
		federationTokenEndpoint: `${env.apiGateway.baseUrl}${env.apiGateway.endpoints.auth}`
	};
}

export function initializeSecurityContextV2(cognitoUser, federationTokenResponse, loginResult) {
	console.log("V2 Initialize Security", federationTokenResponse);
	return new Promise((resolve, reject) => {
		cognitoUser.getSession((err, session) => {
			if (err) {
				reject(err);
				return;
			} else {
				const creds = federationTokenResponse;
				// Hate it but no matter what I tried the browser wouldn't accept the cookies from
				// the set-cookie headers, follow up requests to Cloud Front would fail and we see that
				// the cookies aren't included in the request, expected the browser to just deal with this (Chrome)
				if (creds.cookies && !_.isEmpty(creds.cookies)) {
					const domain = ".ambifi.com";
					const expiresMoment = moment().add(7, "days");
					const cookies = [];
					_.forEach(creds.cookies, (value, key) => {
						state.set(["security", "cookies", key], value);
						cookies.push({
							name: key,
							value,
							domain,
							origin: window.location.href,
							path: "/",
							version: "1",
							expiration: expiresMoment.format("YYYY-MM-DDTHH:mm:ss.sssZ")
						});

					});
					// Signing in: this tab takes the cookies, even from another AmbiFi site open in the browser.
					cloudFrontCookieGuard.sync({ claim: true });
					postMessage({
						method: "cookiesSetRequest",
						cookies
					});
				}
				lastRefresh = Date.now();
				window.awsTempCredentials = AWS.config.credentials = new AWS.Credentials(creds.body.accessKeyId, creds.body.secretAccessKey, creds.body.sessionToken);
				const credentials = new AWS.CognitoIdentityCredentials({
					IdentityPoolId: env.cognito.identityPoolId, // your identity pool id here
					Logins: {
						// Change the key below according to the specific region your user pool is in.
						[env.cognito.loginContext]: loginResult.idToken.jwtToken,
					},
					region: env.aws.defaultRegion,
				});
				window.credentials = credentials;
				postMessage({
					method: "setAwsTempCredentials",
					creds: {
						accessKeyId: creds.body.accessKeyId,
						secretAccessKey: creds.body.secretAccessKey,
						sessionToken: creds.body.sessionToken
					}
				});
				state.set(["user", "_injected_security_credentials"], {
					ak: creds.body.accessKeyId,
					sak: creds.body.secretAccessKey,
					st: creds.body.sessionToken
				});


				setCredentials(session, cognitoUser, resolve, reject, true);

				resolve(federationTokenResponse);


			}
		});
	});
}

const doFetchFederationToken = (jwt = getJwtToken()) => {
	return new Promise((resolve, reject) => {
		request.post(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.auth}`)
			.set("Authorization", jwt)
			.set("Accept", "application/json")
			.then(res => {
				const creds = res.body;
				// Hate it but no matter what I tried the browser wouldn't accept the cookies from
				// the set-cookie headers, follow up requests to Cloud Front would fail and we see that
				// the cookies aren't included in the request, expected the browser to just deal with this (Chrome)
				if (creds.cookies && !_.isEmpty(creds.cookies)) {
					const domain = ".ambifi.com";
					const expiresMoment = moment().add(7, "days");
					const cookies = [];
					_.forEach(creds.cookies, (value, key) => {
						state.set(["security", "cookies", key], value);
						cookies.push({
							name: key,
							value,
							domain,
							origin: window.location.href,
							path: "/",
							version: "1",
							expiration: expiresMoment.format("YYYY-MM-DDTHH:mm:ss.sssZ")
						});

					});
					// A refresh writes them only when the browser doesn't already hold cookies that serve this site.
					cloudFrontCookieGuard.sync();
					postMessage({
						method: "cookiesSetRequest",
						cookies
					});
				}
				lastRefresh = Date.now();
				window.awsTempCredentials = AWS.config.credentials = new AWS.Credentials(creds.body.accessKeyId, creds.body.secretAccessKey, creds.body.sessionToken);


				postMessage({
					method: "setAwsTempCredentials",
					creds: {
						accessKeyId: creds.body.accessKeyId,
						secretAccessKey: creds.body.secretAccessKey,
						sessionToken: creds.body.sessionToken
					}
				});
				state.set(["user", "_injected_security_credentials"], {
					ak: creds.body.accessKeyId,
					sak: creds.body.secretAccessKey,
					st: creds.body.sessionToken
				});
				resolve(creds.body);
			}).catch(err => {
				reject(err);
			});
	});
};

export function urlToSecureParameterObject(url) {
	return {
		url,
		withCredentials: true
	};
}

export function getSecureCookiesAsString() {
	const cookies = [];
	const cookiesMap = state.get(["security", "cookies"]);
	_.keys(cookiesMap).forEach(key => {
		cookies.push(`${key}=${cookiesMap[key]}`);
	});
	return cookies.join("; ");
}
function outOfSync() {
	const curTime = Date.now();
	return !lastRefresh || (curTime - lastRefresh) > 1000 * 60 * REFRESH_INTERVAL_MINUTES || lastRefreshFailed;
}

function getSessionClockDrift(session) {
	const drift = session && _.isFunction(session.getClockDrift) ? session.getClockDrift() : 0;
	return _.isFinite(drift) ? drift : 0;
}

function shouldRenewIdToken(jwtToken, clockDriftSeconds, nowMs = Date.now()) {
	if (!jwtNeedsRenewal(jwtToken, { nowMs, clockDriftSeconds })) {
		return false;
	}

	const attemptedRecently = lastIdTokenRenewalAttempt && nowMs - lastIdTokenRenewalAttempt < 1000 * ID_TOKEN_RENEWAL_RETRY_SECONDS;
	const stillUsable = !jwtNeedsRenewal(jwtToken, { nowMs, clockDriftSeconds, marginSeconds: ID_TOKEN_MIN_USABLE_SECONDS });
	return !(attemptedRecently && stillUsable);
}

/**
 * True when the ID token sent as the API Authorization header (state.user.jwt) is about to expire.
 */
export function idTokenNeedsRenewal(nowMs = Date.now()) {
	return shouldRenewIdToken(getJwtToken(), idTokenClockDriftSeconds, nowMs);
}

function renewCognitoSession(cognitoUser, session) {
	const refreshToken = session && _.isFunction(session.getRefreshToken) ? session.getRefreshToken() : null;

	if (!cognitoUser || !refreshToken || !_.isFunction(cognitoUser.refreshSession)) {
		return Promise.reject(new Error("Unable to refresh the current Cognito session."));
	}

	return new Promise((resolve, reject) => {
		cognitoUser.refreshSession(refreshToken, (err, refreshedSession) => {
			if (err) {
				reject(err);
				return;
			}
			resolve(refreshedSession);
		});
	});
}

async function renewSessionIfIdTokenExpiring(session, cognitoUser) {
	const jwtToken = session?.idToken?.jwtToken;
	const clockDriftSeconds = getSessionClockDrift(session);
	if (!shouldRenewIdToken(jwtToken, clockDriftSeconds)) {
		return session;
	}

	// Recorded even when there is no refresh token so callers don't re-enter the full refresh path
	// on every API call while the current token is still usable.
	lastIdTokenRenewalAttempt = Date.now();
	const refreshToken = session && _.isFunction(session.getRefreshToken) ? session.getRefreshToken() : null;
	if (!refreshToken || !_.isFunction(refreshToken.getToken) || !refreshToken.getToken()) {
		return session;
	}

	try {
		return await renewCognitoSession(cognitoUser, session);
	} catch (err) {
		const stillUsable = !jwtNeedsRenewal(jwtToken, { clockDriftSeconds, marginSeconds: ID_TOKEN_MIN_USABLE_SECONDS });
		if (isSessionExpiredError(err) || !stillUsable) {
			throw err;
		}
		console.warn("Unable to renew the ID token early; using the current token until the next attempt.", getErrorReason(err));
		return session;
	}
}

function getErrorMessage(err) {
	if (_.isString(err)) {
		return err;
	}
	return _.get(err, "message", "");
}

function getErrorCode(err) {
	return (_.get(err, "code", "") || _.get(err, "name", "")).toLowerCase();
}

function getErrorReason(err) {
	const message = getErrorMessage(err);
	if (!_.isEmpty(message)) {
		return message;
	}

	if (_.isNil(err)) {
		return "unknown";
	}

	if (_.isString(err)) {
		return err;
	}

	const asString = `${err}`;
	if (asString && asString !== "[object Object]") {
		return asString;
	}

	return "unknown";
}

function isTransientCredentialRefreshError(err) {
	const message = getErrorMessage(err).toLowerCase();
	const code = getErrorCode(err);

	if (typeof navigator !== "undefined" && navigator.onLine === false) {
		return true;
	}

	return message.includes("network error") ||
		message.includes("networkerror") ||
		message.includes("failed to fetch") ||
		message.includes("request has been terminated") ||
		message.includes("the network is offline") ||
		message.includes("origin is not allowed by access-control-allow-origin") ||
		message.includes("page is being unloaded") ||
		message.includes("load failed") ||
		message.includes("timed out") ||
		message.includes("timeout") ||
		message.includes("cors") ||
		code === "aborterror" ||
		(code === "typeerror" && (message.includes("fetch") || message.includes("network")));
}

function isSessionExpiredError(err) {
	const message = getErrorMessage(err).toLowerCase();
	const code = getErrorCode(err);

	if (message === "no current user") {
		return true;
	}

	if (code === "notauthorizedexception" && (message.includes("token") || message.includes("not authenticated") || message.includes("refresh token"))) {
		return true;
	}

	return message.includes("no current user") ||
		message.includes("not authenticated") ||
		message.includes("token expired") ||
		message.includes("token has expired") ||
		message.includes("refresh token has expired") ||
		message.includes("jwt expired") ||
		message.includes("session expired");
}

function isDefinitiveSessionExpiryError(err) {
	const message = getErrorMessage(err).toLowerCase();
	const code = getErrorCode(err);

	if (message === "no current user") {
		return true;
	}

	return message.includes("token expired") ||
		message.includes("token has expired") ||
		message.includes("refresh token has expired") ||
		message.includes("jwt expired") ||
		message.includes("session expired") ||
		(code === "notauthorizedexception" && message.includes("refresh token"));
}

function isAuthenticationRoute(pathname = "") {
	return pathname === "/" ||
		pathname === "/index.html" ||
		pathname === "/auth" ||
		pathname === "/portalHome" ||
		pathname === "/forgotPassword" ||
		pathname === "/loggedIn" ||
		pathname.startsWith("/login");
}

function isEmbeddedMobileWebView() {
	return !!_.get(window, "ReactNativeWebView");
}

function getEmptyCredentialPayload() {
	return {
		cognitoUser: null,
		credentials: null,
		awsTempCredentials: null,
		awsTempCredentialsPojo: null
	};
}

function clearInMemoryCredentials() {
	lastRefreshFailed = true;
	lastRefresh = null;
	state.set(["user", "loggedIn"], false);
	delete window.credentials;
	delete window.awsTempCredentials;
	cancelCredentialRefreshInterval();
}

function handleSessionExpired(meta = {}) {
	const currentPath = _.get(window, "location.pathname", "");
	const onAuthenticationRoute = isAuthenticationRoute(currentPath);
	const userLoggedIn = !!state.get(["user", "loggedIn"]);
	const mobile = isMobile();
	const embeddedMobileWebView = isEmbeddedMobileWebView();

	clearInMemoryCredentials();

	if (!mobile && !onAuthenticationRoute) {
		if (!sessionExpiryHandled && userLoggedIn) {
			showError("Session Expired", "Your login session expired. Please log in again.");
		}
		sessionExpiryHandled = true;
		forceLogin(browserHistory, currentPath);
	} else if (mobile && embeddedMobileWebView) {
		// In native mobile app, let the app own logout UX/state transitions.
		if (!sessionExpiryHandled) {
			sessionExpiryHandled = true;
			sendDebugLogMessage("Cloud handleSessionExpired sending logout to native", _.assign({
				currentPath,
				onAuthenticationRoute,
				userLoggedIn
			}, meta || {}));
			sendLogoutMessage("web-session-expired", _.assign({
				currentPath
			}, meta || {}));
		}
	} else if (mobile && !onAuthenticationRoute) {
		sessionExpiryHandled = true;
		// Mobile browser fallback.
		forceLogin(browserHistory, currentPath);
	}

	return Promise.resolve(getEmptyCredentialPayload());
}


/**
 * @param {boolean} [force] Refresh even when the credentials are not due.
 * @param {string} [trigger] What asked for it ("visible", "online", "wake", "retry", …), for the failure log.
 */
export function refreshCredentials(force = false, trigger = "") {
	console.log("REFRESH CREDENTIALS");
	if (refreshCredentialsPromise) {
		return refreshCredentialsPromise;
	}

	let attempted = false;
	const refreshPromise = new Promise(async (resolve, reject) => {
		const _outOfSync = outOfSync();
		if (_outOfSync || force || idTokenNeedsRenewal()) {
			console.log("REFRESH REQUIRED");
			attempted = true;
			try {
				let session = await Auth.currentSession();
				const cognitoUser = await Auth.currentAuthenticatedUser();
				session = await renewSessionIfIdTokenExpiring(session, cognitoUser);
				setCredentials(session, cognitoUser, resolve, reject);
			} catch (err) {
				console.error(err);
				reject(err);
			}
			// if (cognitoUser !== null) { // eslint-disable-line
			// 	try {
			// 		const needsRefresh = (window.credentials && window.credentials.needsRefresh());
			// 		cognitoUser.getSession((err, session) => {
			// 			if (err) {
			// 				console.error(err);
			// 				reject(err);
			// 			} else if (needsRefresh) {
			// 				const refresh_token = session.getRefreshToken();
			// 				cognitoUser.refreshSession(refresh_token, (err, session) => {
			// 					if (err) {
			// 						reject(err);
			// 						return;
			// 					} else {
			// 						setCredentials(session, cognitoUser, resolve, reject);
			// 					}
			// 				});
			// 			} else {
			// 				setCredentials(session, cognitoUser, resolve, reject);
			// 			}
			// 		});
			// 	} catch (err) {
			// 		console.error(err);
			// 		reject(err);
			// 	}
			// } else {
			// 	//... What now???
			// 	reject(new Error("Unable to determine current session, please make sure to log in again."));
			// }
		} else {
			console.log("REFRESH NOT REQUIRED");
			let cognitoUser = null;
			try {
				cognitoUser = await Auth.currentAuthenticatedUser();
			} catch (e) {
				console.warn("Unable to fetch current cognito user", e);
			}

			resolve({ cognitoUser, credentials: window.credentials, awsTempCredentials: window.awsTempCredentials, awsTempCredentialsPojo: getAwsTempCredentialsPojo(window.awsTempCredentials) });
		}
		}).then((result) => {
			if (attempted) {
				noteCredentialRefreshSucceeded(trigger);
			}
			return result;
		}).catch(err => {
			console.error(err);
			// A network that isn't there (a computer just woke) is retried soon and silently; an expired session and other
			// errors, which show the refresh error, keep their own handling and schedule.
			noteCredentialRefreshFailed(err, trigger, { retry: !isSessionExpiredError(err) && isTransientCredentialRefreshError(err) });

			if (isSessionExpiredError(err)) {
				const sharedDevice = !!state.get(["user", "sharedDevice"]);
				const definitiveSessionExpiry = isDefinitiveSessionExpiryError(err);
				const sessionExpiryMeta = {
					source: "refreshCredentials",
					reason: getErrorReason(err),
					code: getErrorCode(err),
					sharedDevice,
					definitiveSessionExpiry
				};
				sendDebugLogMessage("Cloud refreshCredentials detected session expiry", sessionExpiryMeta);
				if (isMobile() && !sharedDevice && !definitiveSessionExpiry) {
					return Promise.reject(err);
				}
				return handleSessionExpired(sessionExpiryMeta);
			}

			if (!isMobile()) {
				const currentPath = _.get(window, "location.pathname", "");
				const onAuthenticationRoute = isAuthenticationRoute(currentPath);
				const userLoggedIn = !!state.get(["user", "loggedIn"]);
				const reason = getErrorReason(err);

				// Login/auth routes can race with refresh calls during startup/hot-reload.
				// Suppress noisy refresh popups when the user is already unauthenticated.
				if (onAuthenticationRoute || !userLoggedIn) {
					if (_.isObject(err)) {
						err.handled = true;
						return Promise.reject(err);
					}
					return Promise.reject({
						handled: true,
						reason
					});
				}

				if (isTransientCredentialRefreshError(err)) {
					console.warn("Transient credentials refresh error; will retry automatically.", reason);
					if (_.isObject(err)) {
						err.handled = true;
						return Promise.reject(err);
					}
					return Promise.reject({
						handled: true,
						reason
					});
				}

				showError("Credentials Refresh Error", "We couldn't refresh your security credentials right now. We'll retry automatically. If this keeps happening, refresh the page or log in again. Reason: " + reason);
				if (_.isObject(err)) {
					err.handled = true;
					return Promise.reject(err);
				}
				return Promise.reject({
					handled: true,
					reason
				});
			}

			return Promise.reject(err);
		}).finally(() => {
			if (refreshCredentialsPromise === refreshPromise) {
				refreshCredentialsPromise = null;
			}
		});

	refreshCredentialsPromise = refreshPromise;
	return refreshPromise;
}

export async function refreshCognitoSession() {
	const cognitoUser = await Auth.currentAuthenticatedUser();
	const currentSession = await Auth.currentSession();
	const refreshedSession = await renewCognitoSession(cognitoUser, currentSession);

	return new Promise((resolve, reject) => {
		setCredentials(refreshedSession, cognitoUser, () => resolve(refreshedSession), reject, true);
	});
}

/**
 * Resolve to an ID token for the Authorization header, renewing it first if it is about to expire.
 * Use this where an API call doesn't already await refreshCredentials(). If the renewal fails the
 * current token is returned and refreshCredentials() has already handled session expiry.
 */
export async function getFreshJwtToken() {
	if (idTokenNeedsRenewal()) {
		try {
			await refreshCredentials();
		} catch (err) {
			if (!err || !err.handled) {
				console.warn("Unable to renew the ID token before an API call", err);
			}
		}
	}
	return getJwtToken();
}

function setCredentials(session, cognitoUser, resolve, reject, skipFederationToken = false) {
	const jwtToken = session?.idToken?.jwtToken;
	idTokenClockDriftSeconds = getSessionClockDrift(session);
	// const credentials = new AWS.CognitoIdentityCredentials({
	// 	IdentityPoolId: env.cognito.identityPoolId, // your identity pool id here
	// 	Logins: {
	// 		// Change the key below according to the specific region your user pool is in.
	// 		[env.cognito.loginContext]: jwtToken,
	// 	},
	// 	region: env.aws.defaultRegion,
	// });
	sendTokenUpdatedMessage({ jwt: jwtToken });
	lastRefreshFailed = false;
	sessionExpiryHandled = false;
	if (!skipFederationToken) {
		doFetchFederationToken(jwtToken).then(() => {
			resolve({ cognitoUser, awsTempCredentials: window.awsTempCredentials, awsTempCredentialsPojo: getAwsTempCredentialsPojo(window.awsTempCredentials) });
		}).catch(err => {
			reject(err);
		});
	} else {
		resolve({ cognitoUser, awsTempCredentials: window.awsTempCredentials, awsTempCredentialsPojo: getAwsTempCredentialsPojo(window.awsTempCredentials) });
	}
	// window.credentials = credentials;
	// // console.log("JWT Token", jwtToken);

	// credentials.refresh(() => {
	// 	credentials.get(async (err) => {
	// 		if (!err) {
	// 			lastRefreshFailed = false;
	// 			if (!skipFederationToken) {
	// 				await doFetchFederationToken();
	// 			}

	// 		} else {
	// 			reject(err);
	// 		}
	// 	});
	// });
}

export function captureInviteCode() {
	const code = getQueryStringParam("code");

	// If code returned is a guid then coming from Azure AD and ignore
	// Should handle this better
	if (code && code.length === 36) {
		return;
	}

	if (code && state.get(["inviteMember", "inviteCode"]) === null) {
		console.debug("Got an invite code", code);
		// Ok so there is a code
		state.set(["inviteMember", "inviteCode"], code);
	}
}

/**
 * Stub, currently we only allow admins to edit activities but this will be extened to consult an actual ACL
 * @param {*} activityId 
 */
export function allowedToEditActivity(activityId = null) { //eslint-disable-line
	return isOrganizationAdministrator() || isOrganizationAuthor();
}

export function logout() {

	const user = state.get(["user"]);

	const { rememberMe, savePassword, sharedDevice } = user;

	const newUser = {
		sub: "",
		name: "",
		username: "",
		email: "",
		password: "",
		code: "",
		identityId: "",
		loggedIn: false,
		historyUsers: [],
		entryPoint: "",
		org: null,
		savePassword: !!savePassword,
		rememberMe: !!rememberMe,
		sharedDevice: !!sharedDevice
	};

	state.set(["user"], newUser);
	delete window.credentials;
	delete window.awsTempCredentials;
	refreshCredentialsPromise = null;
	lastRefresh = null;
	lastRefreshFailed = false;
	sessionExpiryHandled = false;
	idTokenClockDriftSeconds = 0;
	lastIdTokenRenewalAttempt = null;
	lastIdTokenWatchdogFailure = null;
	refreshFailures = [];
	refreshRetryCount = 0;
	cancelCredentialRefreshInterval();
}

/**
 * When the CloudFront cookies' signed policy (the CloudFront-Policy cookie) expires, in ms, or null.
 */
export function getCloudFrontPolicyExpiryMs(policy) {
	if (!_.isString(policy) || policy === "") {
		return null;
	}
	try {
		const json = window.atob(decodeURIComponent(policy).replace(/-/g, "+").replace(/_/g, "=").replace(/~/g, "/"));
		const epochSeconds = _.get(JSON.parse(json), ["Statement", 0, "Condition", "DateLessThan", "AWS:EpochTime"]);
		return _.isFinite(epochSeconds) ? epochSeconds * 1000 : null;
	} catch (_err) {
		return null;
	}
}

function cloudFrontCookiesExpireSoon(nowMs = Date.now()) {
	const expiresMs = getCloudFrontPolicyExpiryMs(state.get(["security", "cookies", "CloudFront-Policy"]));
	return expiresMs !== null && expiresMs - nowMs < 1000 * 60 * COOKIE_RENEWAL_MARGIN_MINUTES;
}

// Due now: the 15-minute refresh is overdue, or the ID token or the CloudFront cookies are about to expire.
function credentialsNeedRenewal(nowMs = Date.now()) {
	return outOfSync() || idTokenNeedsRenewal(nowMs) || cloudFrontCookiesExpireSoon(nowMs);
}

function logUnhandledRefreshError(err) {
	if (!err || !err.handled) {
		console.error("Credential refresh error", err);
	}
}

function renewCredentialsIfDue(trigger) {
	if (!state.get(["user", "loggedIn"]) || !credentialsNeedRenewal()) {
		return;
	}
	refreshCredentials(true, trigger).catch(logUnhandledRefreshError);
}

function handleVisibilityChange() {
	if (document.visibilityState === "visible") {
		renewCredentialsIfDue("visible");
	}
}

function handleOnline() {
	renewCredentialsIfDue("online");
}

function clearCredentialRefreshRetry() {
	if (refreshRetryTimerId) {
		window.clearTimeout(refreshRetryTimerId);
		refreshRetryTimerId = null;
	}
}

// Retry a failed refresh after 30 s, then 1, 2 and every 5 minutes, instead of waiting for the 15-minute schedule.
function scheduleCredentialRefreshRetry() {
	if (refreshRetryTimerId || !state.get(["user", "loggedIn"])) {
		return null;
	}
	const delaySeconds = REFRESH_RETRY_DELAYS_SECONDS[Math.min(refreshRetryCount, REFRESH_RETRY_DELAYS_SECONDS.length - 1)];
	refreshRetryCount += 1;
	refreshRetryTimerId = window.setTimeout(() => {
		refreshRetryTimerId = null;
		refreshCredentials(true, "retry").catch(logUnhandledRefreshError);
	}, delaySeconds * 1000);
	return delaySeconds;
}

function noteCredentialRefreshFailed(err, trigger, { retry = true } = {}) {
	const failure = {
		at: new Date(Date.now()).toISOString(),
		trigger: trigger || "refresh",
		reason: getErrorReason(err).slice(0, 300),
		code: getErrorCode(err),
		online: typeof navigator === "undefined" ? null : navigator.onLine !== false,
		visibility: typeof document === "undefined" ? "" : document.visibilityState || ""
	};
	// Only failures that can pass make an outage: "No current user" while someone signs in, or an expired session, is not one.
	if (retry && state.get(["user", "loggedIn"])) {
		refreshFailures = refreshFailures.concat(failure).slice(-MAX_RECORDED_REFRESH_FAILURES);
	}
	const retryInSeconds = retry ? scheduleCredentialRefreshRetry() : null;
	sendDebugLogMessage("Cloud credentials refresh failed", _.assign({}, failure, { failures: refreshFailures.length, retryInSeconds }));
}

function noteCredentialRefreshSucceeded(trigger) {
	clearCredentialRefreshRetry();
	refreshRetryCount = 0;
	if (refreshFailures.length === 0) {
		return;
	}
	const failures = refreshFailures;
	refreshFailures = [];
	const summary = {
		failures: failures.length,
		recoveredBy: trigger || "refresh",
		outageMs: Math.max(0, Date.now() - Date.parse(failures[0].at)),
		firstReason: failures[0].reason
	};
	sendDebugLogMessage("Cloud credentials refresh recovered", summary);
	reportCredentialRefreshRecovery(failures, summary);
}

// One event per recovery, so we can see how often credentials lapse, why, and how long until they recover. It is its
// own event type, which the event endpoint only logs (CloudWatch "ambifiEvent"): a "diagnostic" would be stored as a
// Report Issue report and emailed to support.
function reportCredentialRefreshRecovery(failures, summary) {
	try {
		const endpoint = _.get(env, ["apiGateway", "endpoints", "services", "ambifi", "event"], "/services/ambifi/event");
		const baseUrl = _.toString(_.get(env, ["apiGateway", "baseUrl"], "")).replace(/\/$/, "");
		const jwt = getJwtToken();
		if (!baseUrl || !jwt) {
			return;
		}
		request.post(`${baseUrl}${endpoint}`)
			.set("Content-Type", "application/json")
			.set("Authorization", jwt)
			.send(JSON.stringify({
				type: "credentialRefreshRecovered",
				source: "ambifi-cloud-credential-refresh",
				timestamp: new Date(Date.now()).toISOString(),
				orgId: state.get(["selectedOrg", "id"]) || "",
				userSubId: state.get(["selectedOrg", "userSubId"]) || "",
				currentPath: _.get(window, "location.pathname", ""),
				recoveredBy: summary.recoveredBy,
				outageMs: summary.outageMs,
				failureCount: summary.failures,
				firstReason: summary.firstReason,
				failures
			}))
			.then(() => {}, err => console.warn("Unable to report the credential refresh recovery", err));
	} catch (err) {
		console.warn("Unable to report the credential refresh recovery", err);
	}
}

function checkIdTokenExpiry() {
	const nowMs = Date.now();
	const woke = lastWatchdogTickMs !== null && nowMs - lastWatchdogTickMs > 1000 * WAKE_GAP_SECONDS;
	lastWatchdogTickMs = nowMs;
	// After a sleep everything that is due is renewed at once; cookies about to expire are renewed even when the ID
	// token isn't (unless a retry is already scheduled after a failure).
	const cookiesExpiring = cloudFrontCookiesExpireSoon(nowMs) && !refreshRetryTimerId;
	const due = woke ? credentialsNeedRenewal(nowMs) : (cookiesExpiring || idTokenNeedsRenewal(nowMs));
	if (!due || !state.get(["user", "loggedIn"])) {
		return;
	}
	// On-demand refreshCredentials() calls still retry; the watchdog backs off so a failing
	// renewal doesn't show the refresh error every minute.
	if (lastIdTokenWatchdogFailure && nowMs - lastIdTokenWatchdogFailure < 1000 * 60 * ID_TOKEN_WATCHDOG_BACKOFF_MINUTES) {
		return;
	}

	refreshCredentials(woke || cookiesExpiring, woke ? "wake" : (cookiesExpiring ? "cookies" : "watchdog")).then(() => {
		lastIdTokenWatchdogFailure = null;
	}).catch(err => {
		lastIdTokenWatchdogFailure = Date.now();
		if (!err || !err.handled) {
			console.error("ID token expiry check error", err);
		}
	});
}

export function startCredentialRefreshInterval() {
	if (!intervalId) {
		intervalId = window.setInterval(() => {
			refreshCredentials().catch(err => {
				if (!err || !err.handled) {
					console.error("Credential refresh interval error", err);
				}
			});
		}, 1000 * 60 * REFRESH_INTERVAL_MINUTES);
	}
	if (!idTokenCheckIntervalId) {
		lastWatchdogTickMs = Date.now();
		idTokenCheckIntervalId = window.setInterval(checkIdTokenExpiry, 1000 * ID_TOKEN_CHECK_INTERVAL_SECONDS);
	}
	if (!recoveryListenersAttached) {
		document.addEventListener("visibilitychange", handleVisibilityChange);
		window.addEventListener("online", handleOnline);
		recoveryListenersAttached = true;
	}
	cloudFrontCookieGuard.start();
}

export function cancelCredentialRefreshInterval() {
	if (intervalId) {
		window.clearInterval(intervalId);
		intervalId = null;
	}
	if (idTokenCheckIntervalId) {
		window.clearInterval(idTokenCheckIntervalId);
		idTokenCheckIntervalId = null;
	}
	lastWatchdogTickMs = null;
	clearCredentialRefreshRetry();
	if (recoveryListenersAttached) {
		document.removeEventListener("visibilitychange", handleVisibilityChange);
		window.removeEventListener("online", handleOnline);
		recoveryListenersAttached = false;
	}
	cloudFrontCookieGuard.stop();
}

function getAwsTempCredentialsPojo(awsTempCredentials) {

	let { secretAccessKey, accessKeyId, sessionToken } = awsTempCredentials;

	return {
		secretAccessKey,
		accessKeyId,
		sessionToken
	};
}

export async function getJwtTokenStream(jwt, userId) {
	return new Promise(async (resolve, reject) => {
		try {
			let oauth2Jwt = await request.get(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.jwtOauth2Stream}`)
				.query({ userId })
				.set("Authorization", jwt)
				.set({ "Accept": "application/json" });

			console.log("!*!*!* jwt " + JSON.stringify(oauth2Jwt));

			resolve(oauth2Jwt.body.access_token);
		} catch (err) {
			console.error(err);
			showError("Error", err.message);
			reject(err);
		}
	});
}
